import Vue from "vue";
import base from "./baseIntegration";

export default Object.assign(
    {
        apiUrl: "",

        async rdstation() {
            const url = this.url("/auth/rdstation");
            return Vue.http.get(url);
        },

        async salesforce(id) {
            const url = this.url(`/auth/salesforce/${id}`);
            return Vue.http.get(url);
        }
    },
    base
);
